// extracted by mini-css-extract-plugin
module.exports = {"wallet_login_wrapper":"Login_wallet_login_wrapper__1Fuw8","divider":"Login_divider__3yhZ9","signup":"Login_signup__1qdnI","loginbtn":"Login_loginbtn__2fAEp"};